export class DataQualityHealthTrendSignal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "current",
            "baseName": "current",
            "type": "number",
            "format": "double"
        },
        {
            "name": "slo",
            "baseName": "slo",
            "type": "number",
            "format": "double"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "series",
            "baseName": "series",
            "type": "MetricTimeseries",
            "format": ""
        },
        {
            "name": "newestSeries",
            "baseName": "newestSeries",
            "type": "MetricTimeseries",
            "format": ""
        },
        {
            "name": "field",
            "baseName": "field",
            "type": "FieldConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataQualityHealthTrendSignal.attributeTypeMap;
    }
    constructor() {
    }
}
